import Slick_ from 'react-slick';
// import './slick.css';

let settings = {
  dots: false,
  infinite: false,
  speed: 300,
  centerMode: false,
  variableWidth: true,
  arrows: false,
  slidesToShow: 1,
  swipeToSlide: true,
  adaptiveHeight: true,
  initialSlide: 0,
};

const Slick = props => {
  return (
    <Slick_ className={props.className} {...settings}>
      {props.children}
    </Slick_>
  );
};

export default Slick;
